/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';

import {
  Tr,
  Td,
  LabelWrapper,
  ButtonWrapper,
  SVGWrapper,
  FlexRow,
  RequiredLabel,
  PriceWrapper,
  PriceLabel,
  PriceContent,
  NoteLabel,
  InputWrapper,
  InputContainer,
  InputLabel,
  CheckBoxWrapper,
  CheckBoxLabel,
  StyledCheckBox
} from './css';
import Option from './option';
import EditSVG from '../assets/svg/edit';
import DeleteSVG from '../assets/svg/delete';
import SaveSVG from '../assets/svg/save';
import CancelSVG from '../assets/svg/cancel';
import {
  changeOption,
  changeOptionPricing,
  changeQuestion,
  deleteQuestion,
  saveOption,
  saveOptionPricing,
  saveQuestion,deleteOption
} from './saveSchemaToDB';

const Question = ({
  questionData,
  groupIndex,
  serviceIndex,
  setSavingData,
  questionIndex,
  fullyManagedAdminData,
  setFullyManagedAdminData,
  isLast
}) => {
  const [initialData, setInitialData] = useState([]);
  const {
    name: label,
    note,
    productCatalogOptions: options,
    isRequired
  } = questionData;
  const [questionLabel, setQuestionLabel] = useState(label);
  const [questionNote, setQuestionNote] = useState(note);
  const [questionRequired, setQuestionRequired] = useState(isRequired);
  const [editMode, setEditMode] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [deleteOptions,setDeleteOptions] = useState([]);
  const [dataSaved,setDataSaved] = useState(false);

  const serviceId =
    fullyManagedAdminData[groupIndex].ServicesInGroup[serviceIndex].id;
  let questionId =
    fullyManagedAdminData[groupIndex].ServicesInGroup[serviceIndex]
      .productCatalogQuestions[questionIndex].id;

      // Saving initial microsoftLicensingAdminData
    useEffect(() => {
        const clonedAdminData = JSON.parse(
        JSON.stringify(fullyManagedAdminData)
        );
        setInitialData(clonedAdminData);
        setDataSaved(false);
    }, [dataSaved]);

  // Sync questionLabel with questionData when fullyManagedAdminData changes
  useEffect(() => {
    setQuestionLabel(questionData.name);
    setQuestionNote(questionData.note);
    setQuestionRequired(questionData.isRequired);
  }, [questionData]);

  const checkQuestionValid = () => {
    const clonedAdminData = JSON.parse(JSON.stringify(fullyManagedAdminData));

    const {
      name,
      note,
      productCatalogOptions: options,
      isRequired
    } = clonedAdminData[groupIndex].ServicesInGroup[
      serviceIndex
    ].productCatalogQuestions[questionIndex];

    const isValid =
      name &&
      options.every(
        ({ name, productCatalogPricings: [{ cost, onetimePrice }] }) =>
          name && !isNaN(cost) && !isNaN(onetimePrice)
      );
    return isValid;
  };

  const handleDeleteOptions = async  () => {
    deleteOptions.forEach(async (optionId)=>{
    if(optionId)
        {
            await deleteOption(optionId);
        }

    });
   
  };

  const handleSave = async () => {
    const clonedAdminData = JSON.parse(JSON.stringify(fullyManagedAdminData));

    if(deleteOptions.length !==0)
        {
            await handleDeleteOptions();
        }

    if (checkQuestionValid()) {
        try
        {
            setSavingData(true);
            clonedAdminData[groupIndex].ServicesInGroup[
                serviceIndex
            ].productCatalogQuestions[questionIndex].name = label;
            clonedAdminData[groupIndex].ServicesInGroup[
                serviceIndex
            ].productCatalogQuestions[questionIndex].isSaved = true;
            // Save Service
            clonedAdminData[groupIndex].ServicesInGroup[serviceIndex].isSaved = true;
            // Save Service Group
            clonedAdminData[groupIndex].isSaved = true;

            // Case 1: Update an existing question (questionId already exists)
            if (questionId) {
                // Update the existing question
                await changeQuestion(questionId, {
                name: questionLabel,
                ord:questionIndex,
                isSaved: true,
                note: questionNote,
                isRequired: questionRequired
                });
                // Loop through the options to decide whether to update or save a new option
                const saveOptionPromises = options.map(async (option, index) => {
                const updatedPricing = option.productCatalogPricings[0];
                if (option.id) {
                    // Existing option -> Update with changeOption
                    let pricingId = null;
                    pricingId =
                    option.productCatalogPricings &&
                    option.productCatalogPricings.length > 0
                        ? option.productCatalogPricings[0].id
                        : null;
                    await changeOption(option.id, {
                    questionId,
                    ord:index,
                    name: option.name
                    });
                    if (pricingId) {
                    changeOptionPricing({
                        id: pricingId,
                        cost: +updatedPricing.cost,
                        onetimePrice: +updatedPricing.onetimePrice,
                        costPremium: +updatedPricing.costPremium,
                        onetimePricePremium: +updatedPricing.onetimePricePremium,
                        operationType: 'ADD'
                    });
                    }

                    // eslint-disable-next-line no-else-return
                } else {
                    // New option -> Save with saveOption
                    const newOptionId = await saveOption(questionId, {
                    questionId,
                    ord:index,
                    name: option.name
                    });
                    const newPricingId = await saveOptionPricing(newOptionId, {
                    optionId: newOptionId,
                    cost: +updatedPricing.cost,
                    onetimePrice: +updatedPricing.onetimePrice,
                    costPremium: +updatedPricing.costPremium,
                    onetimePricePremium: +updatedPricing.onetimePricePremium,
                    operationType: 'ADD'
                    });
                    clonedAdminData[groupIndex].ServicesInGroup[
                    serviceIndex
                    ].productCatalogQuestions[questionIndex].productCatalogOptions[
                    index
                    ].id = newOptionId;
                    clonedAdminData[groupIndex].ServicesInGroup[
                        serviceIndex
                    ].productCatalogQuestions[questionIndex].productCatalogOptions[
                        index
                    ].ord = index;
                    clonedAdminData[groupIndex].ServicesInGroup[
                    serviceIndex
                    ].productCatalogQuestions[questionIndex].productCatalogOptions[
                    index
                    ].productCatalogPricings[0].id = newPricingId;
                }
                });

                // Await all promises for saving and updating options
                await Promise.all(saveOptionPromises);
                console.log('All options processed successfully');
            } else {
                // Case 2: New question (no questionId yet, so we need to save it first)
                questionId = await saveQuestion({
                serviceId,
                ord:questionIndex,
                name: questionLabel,
                note: questionNote,
                isRequired: questionRequired,
                isSaved: true
                });

                if (questionId) {
                try {
                    // Save all new options (since this is a new question, all options should be new)
                    const saveOptionPromises = options.map(async (option, index) => {
                    const updatedPricing = option.productCatalogPricings[0];
                    console.log('Saving new option with saveOption');
                    const newOptionId = await saveOption(questionId, {
                        ord:index,
                        questionId,
                        name: option.name
                    });
                    const newPricingId = await saveOptionPricing(newOptionId, {
                        optionId: newOptionId,
                        cost: +updatedPricing.cost,
                        onetimePrice: +updatedPricing.onetimePrice,
                        costPremium: +updatedPricing.costPremium,
                        onetimePricePremium: +updatedPricing.onetimePricePremium,
                        operationType: 'ADD'
                    });

                    clonedAdminData[groupIndex].ServicesInGroup[
                        serviceIndex
                    ].productCatalogQuestions[questionIndex].productCatalogOptions[
                        index
                    ].questionId = questionId;
                    clonedAdminData[groupIndex].ServicesInGroup[
                        serviceIndex
                    ].productCatalogQuestions[questionIndex].productCatalogOptions[
                        index
                    ].id = newOptionId;
                    clonedAdminData[groupIndex].ServicesInGroup[
                        serviceIndex
                    ].productCatalogQuestions[questionIndex].productCatalogOptions[
                        index
                    ].ord = index;
                    clonedAdminData[groupIndex].ServicesInGroup[
                        serviceIndex
                    ].productCatalogQuestions[questionIndex].productCatalogOptions[
                        index
                    ].productCatalogPricings[0].id = newPricingId;
                    clonedAdminData[groupIndex].ServicesInGroup[
                        serviceIndex
                    ].productCatalogQuestions[questionIndex].productCatalogOptions[
                        index
                    ].productCatalogPricings[0].optionId = newOptionId;
                    });

                    // Await saving of all options
                    await Promise.all(saveOptionPromises);
                    console.log('All new options saved successfully');
                } catch (error) {
                    console.error('Error saving options:', error);
                }
                }

                // Update the clonedAdminData with the new questionId
                clonedAdminData[groupIndex].ServicesInGroup[
                serviceIndex
                ].productCatalogQuestions[questionIndex].id = questionId;
                clonedAdminData[groupIndex].ServicesInGroup[
                    serviceIndex
                ].productCatalogQuestions[questionIndex].ord = questionIndex;
                clonedAdminData[groupIndex].ServicesInGroup[
                serviceIndex
                ].productCatalogQuestions[questionIndex].serviceId = serviceId;
            }

            // Update the fully managed admin data and exit edit mode
            setFullyManagedAdminData(clonedAdminData);
            setEditMode(false);
            setDataSaved(true);

        }
        catch{
            console.log("An error occurred while saving data");
                setSavingData(false);
        }
        finally{
            setSavingData(false);
        }
    }

  };

  const handleDeleteQuestion = async () => {
    const clonedAdminData = JSON.parse(JSON.stringify(fullyManagedAdminData));

    // Ensure that there is a questionId and more than one question before proceeding
    if (
      questionId &&
      clonedAdminData[groupIndex].ServicesInGroup[serviceIndex]
        .productCatalogQuestions.length > 1
    ) {
      try {
        // Await the deletion of the question from the database
        await deleteQuestion(questionId);

        // Remove the question from the clonedAdminData
        clonedAdminData[groupIndex].ServicesInGroup[
          serviceIndex
        ].productCatalogQuestions.splice(questionIndex, 1);

        // Update the state with the new data
        setFullyManagedAdminData(clonedAdminData);
        setEditMode(false);
      } catch (error) {
        console.error('Error deleting question:', error);
      }
    } else if (!questionId) {
      clonedAdminData[groupIndex].ServicesInGroup[
        serviceIndex
      ].productCatalogQuestions.splice(questionIndex, 1);

      // Update the state with the new data
      setFullyManagedAdminData(clonedAdminData);
      setEditMode(false);
    }
  };

  const handleCancel = () => {
    setDeleteOptions([]);
    if (!checkQuestionValid() && !questionId) {
      handleDeleteQuestion();
    } else {
      const clonedAdminData = JSON.parse(JSON.stringify(initialData));
      const newOptions = clonedAdminData[groupIndex].ServicesInGroup[
        serviceIndex
      ].productCatalogQuestions[questionIndex].productCatalogOptions;
      const filteredOptions = newOptions.filter(option=>option.id && option.name);
      clonedAdminData[groupIndex].ServicesInGroup[
        serviceIndex
      ].productCatalogQuestions[questionIndex].productCatalogOptions = filteredOptions;
      setFullyManagedAdminData(clonedAdminData);
      setEditMode(false);
    }
  };

  useEffect(() => {
    if (!questionLabel) setEditMode(true);
  }, []);

  useEffect(() => {
    setSelectedOption(null);
  }, [editMode]);

  useEffect(() => {
    const clonedAdminData = JSON.parse(JSON.stringify(fullyManagedAdminData));
    clonedAdminData[groupIndex].ServicesInGroup[
      serviceIndex
    ].productCatalogQuestions[questionIndex].name = questionLabel;
    clonedAdminData[groupIndex].ServicesInGroup[
      serviceIndex
    ].productCatalogQuestions[questionIndex].note = questionNote;
    clonedAdminData[groupIndex].ServicesInGroup[
      serviceIndex
    ].productCatalogQuestions[questionIndex].isRequired = questionRequired;
    setFullyManagedAdminData(clonedAdminData);
  }, [questionLabel, questionNote, questionRequired]);

  return (
    <>
      <Tr>
        <Td background="#f7f7f7">
          <LabelWrapper>
            {editMode ? (
              <InputWrapper>
                <InputContainer>
                  <InputLabel>Question Label</InputLabel>
                  <input
                    type="text"
                    style={{
                      width: '330px',
                      borderColor: questionLabel ? '#e4e4e4' : '#C12335'
                    }}
                    value={questionLabel}
                    onChange={e => setQuestionLabel(e.target.value)}
                  />
                  {!questionLabel && <RequiredLabel>Required</RequiredLabel>}
                </InputContainer>
                <InputContainer>
                  <InputLabel>Note</InputLabel>
                  <input
                    type="text"
                    style={{
                      width: '330px'
                    }}
                    value={questionNote}
                    onChange={e => setQuestionNote(e.target.value)}
                  />
                </InputContainer>
                {/*  Checkbox for required questions */}
                <CheckBoxWrapper>
                  <StyledCheckBox
                    id="checkbox-id"
                    checked={questionRequired}
                    onChange={e => setQuestionRequired(e.target.checked)}
                  />
                  <CheckBoxLabel htmlFor="checkbox-id">Required</CheckBoxLabel>
                </CheckBoxWrapper>
              </InputWrapper>
            ) : (
              <div>
                <p>
                  {questionLabel}
                  {questionLabel && questionRequired ? '*' : ''}
                </p>
                {note && <NoteLabel>{note}</NoteLabel>}
              </div>
            )}
            <ButtonWrapper>
              {editMode ? (
                <>
                  <SVGWrapper onClick={handleCancel}>
                    <CancelSVG />
                  </SVGWrapper>
                  <SVGWrapper onClick={handleSave}>
                    <SaveSVG />
                  </SVGWrapper>
                </>
              ) : (
                <>
                  <SVGWrapper onClick={() => setEditMode(!editMode)}>
                    <EditSVG />
                  </SVGWrapper>
                  {!isLast && (
                    <SVGWrapper onClick={handleDeleteQuestion}>
                      <DeleteSVG size="22" />
                    </SVGWrapper>
                  )}
                </>
              )}
            </ButtonWrapper>
          </LabelWrapper>
        </Td>
        {editMode ? (
          <Option
            key={options[0].id}
            setInitialData={setInitialData}
            optionData={options[0]}
            isFirst={true}
            isLast={options.length === 1}
            groupIndex={groupIndex}
            serviceIndex={serviceIndex}
            questionIndex={questionIndex}
            optionIndex={0}
            fullyManagedAdminData={fullyManagedAdminData}
            setFullyManagedAdminData={setFullyManagedAdminData}
            deleteOptions={deleteOptions}
            setDeleteOptions={setDeleteOptions}
          />
        ) : (
          <>
            <Td>
              <select onChange={e => setSelectedOption(e.target.value)}>
                <option value="">Select</option>
                {options.map((optionItem, index) => (
                  <option value={index}>{optionItem.name}</option>
                ))}
              </select>
            </Td>
            <Td>
              {selectedOption ? (
                <>
                  <PriceWrapper>
                    <PriceLabel>Regular</PriceLabel>
                    <PriceContent>{`$${options[selectedOption].productCatalogPricings[0].cost}`}</PriceContent>
                  </PriceWrapper>
                  {+options[selectedOption].productCatalogPricings[0]
                    .costPremium > 0 && (
                    <PriceWrapper>
                      <PriceLabel>Premium</PriceLabel>
                      <PriceContent>{`$${options[selectedOption].productCatalogPricings[0].costPremium}`}</PriceContent>
                    </PriceWrapper>
                  )}
                </>
              ) : (
                '-'
              )}
            </Td>
            <Td>
              {selectedOption ? (
                <>
                  <PriceWrapper>
                    <PriceLabel>Regular</PriceLabel>
                    <PriceContent>{`$${options[selectedOption].productCatalogPricings[0].onetimePrice}`}</PriceContent>
                  </PriceWrapper>
                  {+options[selectedOption].productCatalogPricings[0]
                    .onetimePricePremium > 0 && (
                    <PriceWrapper>
                      <PriceLabel>Premium</PriceLabel>
                      <PriceContent>{`$${options[selectedOption].productCatalogPricings[0].onetimePricePremium}`}</PriceContent>
                    </PriceWrapper>
                  )}
                </>
              ) : (
                '-'
              )}
            </Td>
          </>
        )}
      </Tr>
      {editMode &&
        options
          .slice(1)
          .map((optionData, index) => (
            <Option
              key={optionData.id || index}
              setInitialData={setInitialData}
              optionData={optionData}
              isFirst={false}
              isLast={index === options.length - 2}
              groupIndex={groupIndex}
              serviceIndex={serviceIndex}
              questionIndex={questionIndex}
              optionIndex={index + 1}
              fullyManagedAdminData={fullyManagedAdminData}
              setFullyManagedAdminData={setFullyManagedAdminData}
              deleteOptions={deleteOptions}
            setDeleteOptions={setDeleteOptions}
            />
          ))}
    </>
  );
};

export default Question;
